import BasePageMixin from './BasePageMixin';
import { asBoolean } from 'core/utils';

export default {
  mixins: [ BasePageMixin ],

  props: {
    forceEdit: {
      type: Boolean,
      default: false,
    }
  },

  created() {
    this.onLoadSuccess = this.onLoadSuccess.bind(this);
    this.onLoadError = this.onLoadError.bind(this);
    this.onInsertSuccess = this.onInsertSuccess.bind(this);
    this.onInsertError = this.onInsertError.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.onUpdateError = this.onUpdateError.bind(this);
  },

  data() {
    return {
      params: null,
      query: null,
      instance: null,
      errors: null,
      dirtyInstance: false,
    };
  },

  computed: {
    editing() {
      // console.log('query', this.query);
      const paramEdit = this.params && this.params.id === 'new';
      const queryEdit = this.query && asBoolean(this.query.edit);
      return paramEdit || queryEdit || this.forceEdit;
    }
  },

  watch: {
    '$route': function(to, from) {
      // console.log('$route', to, from);
      this.load();
    },

    instance(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dirtyInstance = true;
      }
    },
  },

  mounted() {
    this.load();
  },

  beforeRouteLeave (to, from, next) {
    if (this.editing && this.dirtyInstance) {
      const answer = to.data && to.data.noAlert
          ? true
          : window.confirm('Sei sicuro di voler abbandonare la pagina corrente?\nTutti i dati non salvati andranno persi.')
          ;
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

  methods: {
    cancel() {
      console.log('VIRTUAL METHOD: cancel()');
    },

    edit() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          edit: 1,
        }
      });
    },

    unedit() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          edit: undefined,
        }
      });
    },

    load() {
      console.log('Loading', this.$route);

      const id = this.$route.params.id;

      const prom = id === 'new'
          ? this.service.create()
          : this.service.load({ id })
          ;

      this.loading = true;
      prom.then(this.onLoadSuccess, this.onLoadError);
    },

    onLoadSuccess({ statusCode, data}) {
      console.log('onLoadSuccess', statusCode, data);
      this.instance = data;
      this.loading = false;
      this.params = this.$route.params;
      this.query = this.$route.query;
    },

    onLoadError({ statusCode, data }) {
      const key = 'onError' + statusCode;
      if (this[key]) {
        this[key]({ statusCode, data });
      } else {
        this.onAnyError({ statusCode, data });
      }
      this.loading = false;
    },

    save() {
      if (this.$route.params.id !== 'new') {
        this.update();
      } else {
        this.insert();
      }
    },

    insert() {
      const instance = this.instance;

      this.loading = true;
      this.errors = null;
      this.service.insert({ instance })
          .then(this.onInsertSuccess, this.onInsertError);
    },

    onInsertSuccess({ statusCode, data}) {
      console.log('Insert success', data);
      const newRoute = {
        name: this.$route.name,
        params: {
          id: data.id,
        }
      };
      console.log('newRoute', newRoute);
      this.$router.push(newRoute);
    },

    onInsertError({ statusCode, data }) {
      return this.onLoadError({ statusCode, data });
    },

    update() {
      const id = this.$route.params.id;
      const instance = this.instance;

      this.loading = true;
      this.errors = null;
      this.service.update({ id, instance })
          .then(this.onUpdateSuccess, this.onUpdateError);
    },

    onUpdateSuccess({ statusCode, data}) {
      this.$router.push({
        ...this.$route,
        params: {
          ...this.$route.params,
          id: data.id,
        },
        query: {
          ...this.$route.query,
          edit: undefined,
        }
      });
    },

    onUpdateError({ statusCode, data }) {
      return this.onInsertError({ statusCode, data });
    },

    remove() {
      const id = this.$route.params.id;

      this.loading = true;
      this.service.remove({ id })
          .then(this.onRemoveSuccess, this.onRemoveError);
    },

    onRemoveSuccess({ statusCode, data}) {
      console.log('onRemoveSuccess', statusCode, data);
      this.loading = false;
    },

    onRemoveError({ statusCode, data }) {
      return this.onLoadError({ statusCode, data });
    },
  }
};
